var conteudo =
"NB615319998BR,14/08/23\n" +
"NB625319998BR,30/08/23\n" +
"NB635319998BR,04/09/23\n" +
"NB645319998BR,13/09/23\n" +
"NB655319998BR,15/09/23\n" +
"NB665319998BR,20/09/23\n" +
"NB675319998BR,27/09/23\n" +
"NL919114724BR,07/10/23\n" +
"NL860429859BR,13/09/23\n" +
"NL860427393BR,13/09/23\n" +
"NL860425959BR,13/09/23\n" +
"NL860428907BR,13/09/23\n" +
"NL860423428BR,13/09/23\n" +
"NL860423768BR,13/09/23\n" +
"NL860429332BR,13/09/23\n" +
"NL860427861BR,13/09/23\n" +
"NL860428840BR,13/09/23\n" +
"NL860427331BR,13/09/23\n" +
"NL860418799BR,13/09/23\n" +
"NL860423167BR,13/09/23\n" +
"NL860424352BR,13/09/23\n" +
"NL860421078BR,13/09/23\n" +
"NL860421930BR,13/09/23\n" +
"NL860421435BR,13/09/23\n" +
"NL860423913BR,13/09/23\n" +
"NL860423745BR,13/09/23\n" +
"NL860418785BR,13/09/23\n" +
"NL860421020BR,13/09/23\n" +
"NL860420611BR,13/09/23\n" +
"NL860420585BR,13/09/23\n" +
"NL860418768BR,13/09/23\n" +
"NL860424335BR,13/09/23\n" +
"NL860422949BR,13/09/23\n" +
"NL860417691BR,13/09/23\n" +
"NL860421016BR,13/09/23\n" +
"NL860419803BR,13/09/23\n" +
"NL860420086BR,13/09/23\n" +
"NL860420815BR,13/09/23\n" +
"NL860418167BR,13/09/23\n" +
"NL860422864BR,13/09/23\n" +
"NL860424216BR,13/09/23\n" +
"NL860420982BR,13/09/23\n" +
"NL860419573BR,13/09/23\n" +
"NL889447730BR,23/09/23\n" +
"NL889445795BR,23/09/23\n" +
"NL889444795BR,23/09/23\n" +
"NL889447289BR,23/09/23\n" +
"NL889452434BR,23/09/23\n" +
"NL889448695BR,23/09/23\n" +
"NL889450478BR,23/09/23\n" +
"NL889450481BR,23/09/23\n" +
"NL889447292BR,23/09/23\n" +
"NL889451425BR,23/09/23\n" +
"NL889451411BR,23/09/23\n" +
"NL889449568BR,23/09/23\n" +
"NL889448681BR,23/09/23\n" +
"NL889444804BR,23/09/23\n" +
"NL889450005BR,23/09/23\n" +
"NL889449951BR,23/09/23\n" +
"NL889447261BR,23/09/23\n" +
"NL889450946BR,23/09/23\n" +
"NL889447726BR,23/09/23\n" +
"NL889447301BR,23/09/23\n" +
"NL889448307BR,23/09/23\n" +
"NL889452859BR,23/09/23\n" +
"NL889450518BR,23/09/23\n" +
"NL889447757BR,23/09/23\n" +
"NL889619845BR,23/09/23\n" +
"NL889449965BR,23/09/23\n" +
"NL889447712BR,23/09/23\n" +
"NL889448315BR,23/09/23\n" +
"NL889449982BR,23/09/23\n" +
"NL889452425BR,23/09/23\n" +
"NL889448704BR,23/09/23\n" +
"NL889449130BR,23/09/23\n" +
"NL889447275BR,23/09/23\n" +
"NL889450464BR,23/09/23\n" +
"NL889449996BR,23/09/23\n" +
"NL889449126BR,23/09/23\n" +
"NL889459358BR,23/09/23\n" +
"NL889452845BR,23/09/23\n" +
"NL889448664BR,23/09/23\n" +
"NL889450447BR,23/09/23\n" +
"NL889451399BR,23/09/23\n" +
"NL889447743BR,23/09/23\n" +
"NL889617411BR,23/09/23\n" +
"NL889450950BR,23/09/23\n" +
"NL889449979BR,23/09/23\n" +
"NL889450455BR,23/09/23\n" +
"NL889452831BR,23/09/23\n" +
"NL889451408BR,23/09/23\n" +
"NL889447258BR,23/09/23\n" +
"NL889452417BR,23/09/23\n" +
"NL891653267BR,26/09/23\n" +
"NL891745480BR,26/09/23\n" +
"NL891656192BR,26/09/23\n" +
"NL891657944BR,26/09/23\n" +
"NL891655210BR,26/09/23\n" +
"NL891655594BR,26/09/23\n" +
"NL891656189BR,26/09/23\n" +
"NL891658896BR,26/09/23\n" +
"NL891653298BR,26/09/23\n" +
"NL891653275BR,26/09/23\n" +
"NL891657105BR,26/09/23\n" +
"NL891656175BR,26/09/23\n" +
"NL891741806BR,26/09/23\n" +
"NL891653735BR,26/09/23\n" +
"NL891655223BR,26/09/23\n" +
"NL891651297BR,26/09/23\n" +
"NL891656626BR,26/09/23\n" +
"NL891659335BR,26/09/23\n" +
"NL891739201BR,26/09/23\n" +
"NL891659865BR,26/09/23\n" +
"NL891659843BR,26/09/23\n" +
"NL891654262BR,26/09/23\n" +
"NL891657652BR,26/09/23\n" +
"NL891743869BR,26/09/23\n" +
"NL891657958BR,26/09/23\n" +
"NL891659888BR,26/09/23\n" +
"NL891656158BR,26/09/23\n" +
"NL891659874BR,26/09/23\n" +
"NL891657635BR,26/09/23\n" +
"NL891747344BR,26/09/23\n" +
"NL891654276BR,26/09/23\n" +
"NL891653284BR,26/09/23\n" +
"NL891657666BR,26/09/23\n" +
"NL891657649BR,26/09/23\n" +
"NL891742231BR,26/09/23\n" +
"NL891657961BR,26/09/23\n" +
"NL891659344BR,26/09/23\n" +
"NL891658423BR,26/09/23\n" +
"NL891658406BR,26/09/23\n" +
"NL891657683BR,26/09/23\n" +
"NL891671402BR,26/09/23\n" +
"NL891656144BR,26/09/23\n" +
"NL891659857BR,26/09/23\n" +
"NL891747335BR,26/09/23\n" +
"NL891658397BR,26/09/23\n" +
"NL891656201BR,26/09/23\n" +
"NL891659358BR,26/09/23\n" +
"NL891651306BR,26/09/23\n" +
"NL891656135BR,26/09/23\n" +
"NL891655617BR,26/09/23\n" +
"NL891656612BR,26/09/23\n" +
"NL891657670BR,26/09/23\n" +
"NL891656161BR,26/09/23\n" +
"NL891657935BR,26/09/23\n" +
"NL891748322BR,26/09/23\n" +
"NL891742228BR,26/09/23\n" +
"NL891658410BR,26/09/23\n" +
"NL891655603BR,26/09/23\n" +
"NL900373276BR,29/09/23\n" +
"NL900375541BR,29/09/23\n" +
"NL900374197BR,29/09/23\n" +
"NL900374665BR,29/09/23\n" +
"NL900690305BR,29/09/23\n" +
"NL900375524BR,29/09/23\n" +
"NL900373262BR,29/09/23\n" +
"NL900687677BR,29/09/23\n" +
"NL900377922BR,29/09/23\n" +
"NL900378463BR,29/09/23\n" +
"NL900375966BR,29/09/23\n" +
"NL900373545BR,29/09/23\n" +
"NL900379336BR,29/09/23\n" +
"NL900376961BR,29/09/23\n" +
"NL900374651BR,29/09/23\n" +
"NL900375572BR,29/09/23\n" +
"NL900373585BR,29/09/23\n" +
"NL900690778BR,29/09/23\n" +
"NL900378432BR,29/09/23\n" +
"NL900378928BR,29/09/23\n" +
"NL900377511BR,29/09/23\n" +
"NL900373554BR,29/09/23\n" +
"NL900375008BR,29/09/23\n" +
"NL900379353BR,29/09/23\n" +
"NL900378945BR,29/09/23\n" +
"NL900378429BR,29/09/23\n" +
"NL900375970BR,29/09/23\n" +
"NL900378450BR,29/09/23\n" +
"NL900376944BR,29/09/23\n" +
"NL900378931BR,29/09/23\n" +
"NL900375983BR,29/09/23\n" +
"NL900377485BR,29/09/23\n" +
"NL900379340BR,29/09/23\n" +
"NL900372810BR,29/09/23\n" +
"NL900375569BR,29/09/23\n" +
"NL900377936BR,29/09/23\n" +
"NL900376445BR,29/09/23\n" +
"NL900376431BR,29/09/23\n" +
"NL900377508BR,29/09/23\n" +
"NL900375011BR,29/09/23\n" +
"NL900373568BR,29/09/23\n" +
"NL900376958BR,29/09/23\n" +
"NL900379322BR,29/09/23\n" +
"NL900373599BR,29/09/23\n" +
"NL900374679BR,29/09/23\n" +
"NL900377499BR,29/09/23\n" +
"NL900375025BR,29/09/23\n" +
"NL900377953BR,29/09/23\n" +
"NL900375555BR,29/09/23\n" +
"NL900375538BR,29/09/23\n" +
"NL900372797BR,29/09/23\n" +
"NL900377975BR,29/09/23\n" +
"NL900694457BR,29/09/23\n" +
"NL900374648BR,29/09/23\n" +
"NL900373571BR,29/09/23\n" +
"NL900378415BR,29/09/23\n" +
"NL900378914BR,29/09/23\n" +
"NL900377468BR,29/09/23\n" +
"NL900374634BR,29/09/23\n" +
"NL900372806BR,29/09/23\n" +
"NL900378446BR,29/09/23\n" +
"NL900375952BR,29/09/23\n" +
"NL900372783BR,29/09/23\n" +
"NL900372770BR,29/09/23\n" +
"NL900372315BR,29/09/23\n" +
"NL900377940BR,29/09/23\n" +
"NL900691331BR,29/09/23\n" +
"NL900378477BR,29/09/23\n" +
"NL900690764BR,29/09/23\n" +
"NL902622271BR,02/10/23\n" +
"NL902622285BR,02/10/23\n" +
"NL902625065BR,02/10/23\n" +
"NL902621775BR,02/10/23\n" +
"NL902621789BR,02/10/23\n" +
"NL902621792BR,02/10/23\n" +
"NL902682730BR,02/10/23\n" +
"NL902686657BR,02/10/23\n" +
"NL902626450BR,02/10/23\n" +
"NL902624136BR,02/10/23\n" +
"NL902624140BR,02/10/23\n" +
"NL902622679BR,02/10/23\n" +
"NL902621228BR,02/10/23\n" +
"NL902624175BR,02/10/23\n" +
"NL902625635BR,02/10/23\n" +
"NL902624564BR,02/10/23\n" +
"NL902626931BR,02/10/23\n" +
"NL902687927BR,02/10/23\n" +
"NL902627906BR,02/10/23\n" +
"NL902623657BR,02/10/23\n" +
"NL902627897BR,02/10/23\n" +
"NL902625644BR,02/10/23\n" +
"NL902621231BR,02/10/23\n" +
"NL902624578BR,02/10/23\n" +
"NL902627441BR,02/10/23\n" +
"NL902684625BR,02/10/23\n" +
"NL902684259BR,02/10/23\n" +
"NL902623665BR,02/10/23\n" +
"NL902627883BR,02/10/23\n" +
"NL902624153BR,02/10/23\n" +
"NL902627870BR,02/10/23\n" +
"NL902625613BR,02/10/23\n" +
"NL902625627BR,02/10/23\n" +
"NL902624167BR,02/10/23\n" +
"NL902626928BR,02/10/23\n" +
"NL902622682BR,02/10/23\n" +
"NL902623643BR,02/10/23\n" +
"NL902623630BR,02/10/23\n" +
"NL902624555BR,02/10/23\n" +
"NL902627469BR,02/10/23\n" +
"NL902688896BR,02/10/23\n" +
"NL902627455BR,02/10/23\n" +
"NL902634181BR,02/10/23\n" +
"NL902623158BR,02/10/23\n" +
"NL910012351BR,05/10/23\n" +
"NL909988586BR,05/10/23\n" +
"NL909992413BR,05/10/23\n" +
"NL909992930BR,05/10/23\n" +
"NL909993833BR,05/10/23\n" +
"NL909990960BR,05/10/23\n" +
"NL910010024BR,05/10/23\n" +
"NL909990514BR,05/10/23\n" +
"NL909989555BR,05/10/23\n" +
"NL909987784BR,05/10/23\n" +
"NL909989578BR,05/10/23\n" +
"NL909991466BR,05/10/23\n" +
"NL909990148BR,05/10/23\n" +
"NL909989140BR,05/10/23\n" +
"NL909987798BR,05/10/23\n" +
"NL909987807BR,05/10/23\n" +
"NL909992943BR,05/10/23\n" +
"NL909988189BR,05/10/23\n" +
"NL909990528BR,05/10/23\n" +
"NL909989564BR,05/10/23\n" +
"NL909993419BR,05/10/23\n" +
"NL910011435BR,05/10/23\n" +
"NL912347415BR,06/10/23\n" +
"NL912348384BR,06/10/23\n" +
"NL912344498BR,06/10/23\n" +
"NL912343563BR,06/10/23\n" +
"NL912346882BR,06/10/23\n" +
"NL912347389BR,06/10/23\n" +
"NL912341806BR,06/10/23\n" +
"NL912346485BR,06/10/23\n" +
"NL912344997BR,06/10/23\n" +
"NL912346499BR,06/10/23\n" +
"NL912346012BR,06/10/23\n" +
"NL912343149BR,06/10/23\n" +
"NL912395336BR,06/10/23\n" +
"NL912393437BR,06/10/23\n" +
"NL912346057BR,06/10/23\n" +
"NL912347401BR,06/10/23\n" +
"NL912344095BR,06/10/23\n" +
"NL912349328BR,06/10/23\n" +
"NL912345555BR,06/10/23\n" +
"NL912343121BR,06/10/23\n" +
"NL912348353BR,06/10/23\n" +
"NL912344983BR,06/10/23\n" +
"NL912348375BR,06/10/23\n" +
"NL912344087BR,06/10/23\n" +
"NL912392652BR,06/10/23\n" +
"NL912347392BR,06/10/23\n" +
"NL912341810BR,06/10/23\n" +
"NL912346896BR,06/10/23\n" +
"NL912342656BR,06/10/23\n" +
"NL912343532BR,06/10/23\n" +
"NL912345533BR,06/10/23\n" +
"NL912348821BR,06/10/23\n" +
"NL912343135BR,06/10/23\n" +
"NL912392649BR,06/10/23\n" +
"NL912343550BR,06/10/23\n" +
"NL912343529BR,06/10/23\n" +
"NL912347429BR,06/10/23\n" +
"NL912346043BR,06/10/23\n" +
"NL912346030BR,06/10/23\n" +
"NL912343546BR,06/10/23\n" +
"NL912345547BR,06/10/23\n" +
"NL912348835BR,06/10/23\n" +
"NL912343152BR,06/10/23\n" +
"NL912348367BR,06/10/23\n" +
"NL912393131BR,06/10/23\n" +
"NL912344484BR,06/10/23\n" +
"NL912348849BR,06/10/23\n" +
"NL912347888BR,06/10/23\n" +
"NL912388777BR,06/10/23\n" +
"NL912346026BR,06/10/23\n" +
"NL912345564BR,06/10/23\n" +
"NL919120910BR,10/10/23\n" +
"NL919119426BR,10/10/23\n" +
"NL919126152BR,10/10/23\n" +
"NL919117663BR,10/10/23\n" +
"NL919114715BR,10/10/23\n" +
"NL919121040BR,10/10/23\n" +
"NL919115659BR,10/10/23\n" +
"NL919117629BR,10/10/23\n" +
"NL919120945BR,10/10/23\n" +
"NL919120937BR,10/10/23\n" +
"NL919121844BR,10/10/23\n" +
"NL919116725BR,10/10/23\n" +
"NL919127515BR,10/10/23\n" +
"NL919118160BR,10/10/23\n" +
"NL919119077BR,10/10/23\n" +
"NL919119390BR,10/10/23\n" +
"NL919120971BR,10/10/23\n" +
"NL919115676BR,10/10/23\n" +
"NL919125713BR,10/10/23\n" +
"NL919120954BR,10/10/23\n" +
"NL919128388BR,10/10/23\n" +
"NL919115631BR,10/10/23\n" +
"NL919120968BR,10/10/23\n" +
"NL919122725BR,10/10/23\n" +
"NL919116274BR,10/10/23\n" +
"NL919116314BR,10/10/23\n" +
"NL919121005BR,10/10/23\n" +
"NL919115645BR,10/10/23\n" +
"NL919118638BR,10/10/23\n" +
"NL919120469BR,10/10/23\n" +
"NL919119369BR,10/10/23\n" +
"NL919123814BR,10/10/23\n" +
"NL919121376BR,10/10/23\n" +
"NL919117235BR,10/10/23\n" +
"NL919116773BR,10/10/23\n" +
"NL919129468BR,10/10/23\n" +
"NL919119386BR,10/10/23\n" +
"NL919115680BR,10/10/23\n" +
"NL919119063BR,10/10/23\n" +
"NL919115662BR,10/10/23\n" +
"NL919114741BR,10/10/23\n" +
"NL919120985BR,10/10/23\n" +
"NL919118615BR,10/10/23\n" +
"NL919117646BR,10/10/23\n" +
"NL919118624BR,10/10/23\n" +
"NL919116742BR,10/10/23\n" +
"NL919119412BR,10/10/23\n" +
"NL919116760BR,10/10/23\n" +
"NL919117677BR,10/10/23\n" +
"NL919121861BR,10/10/23\n" +
"NL919114707BR,10/10/23\n" +
"NL919117249BR,10/10/23\n" +
"NL919117650BR,10/10/23\n" +
"NL919118607BR,10/10/23\n" +
"NL919122337BR,10/10/23\n" +
"NL919116288BR,10/10/23\n" +
"NL919121380BR,10/10/23\n" +
"NL919117266BR,10/10/23\n" +
"NL919116305BR,10/10/23\n" +
"NL919128405BR,10/10/23\n" +
"NL919119050BR,10/10/23\n" +
"NL919119925BR,10/10/23\n" +
"NL919120906BR,10/10/23\n" +
"NL919119372BR,10/10/23\n" +
"NL919116291BR,10/10/23\n" +
"NL919119911BR,10/10/23\n" +
"NL919120999BR,10/10/23\n" +
"NL919128935BR,10/10/23\n" +
"NL919114755BR,10/10/23\n" +
"NL919118187BR,10/10/23\n" +
"NL919121022BR,10/10/23\n" +
"NL919120923BR,10/10/23\n" +
"NL919121858BR,10/10/23\n" +
"NL919121393BR,10/10/23\n" +
"NL919130832BR,10/10/23\n" +
"NL919125188BR,10/10/23\n" +
"NL919114769BR,10/10/23\n" +
"NL919116739BR,10/10/23\n" +
"NL919114772BR,10/10/23\n" +
"NL919116787BR,10/10/23\n" +
"NL919128017BR,10/10/23\n" +
"NL919117632BR,10/10/23\n" +
"NL919121053BR,10/10/23\n" +
"NL919126166BR,10/10/23\n" +
"NL919119409BR,10/10/23\n" +
"NL919117252BR,10/10/23\n" +
"NL919119085BR,10/10/23\n" +
"NL919114738BR,10/10/23\n" +
"NL919120472BR,10/10/23\n" +
"NL919121019BR,10/10/23\n" +
"NL919119443BR,10/10/23\n" +
"NL919116756BR,10/10/23\n" +
"NL919118173BR,10/10/23\n" +
"NL919121362BR,10/10/23\n" +
"NL919126183BR,10/10/23\n" +
"NL919121875BR,10/10/23\n" +
"NL919118195BR,10/10/23\n" +
"NL919119094BR,10/10/23\n" +
"NL919119908BR,10/10/23\n" +
"NL919124284BR,10/10/23\n" +
"NL919120486BR,10/10/23";